export default __webpack_public_path__ + "assets/images/56b4e871050afc8cb7fc9e1162426a58.png";